const styles = (theme) => ({
  severityIcon: {
    paddingRight: 4,
  },
  outerContainer: {
    padding: "0 10px 0 20px",
  },
  textStyles: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    lineHeight: "16px",
  },
  section: {
    display: "flex",
    marginBottom: 8
  },
  comment: {
    fontWeight: 400,
  },
  showMore: {
    fontWeight: 600,
    marginTop: 5,
    cursor: "pointer",
  },
  showAll: {
    fontSize: theme.textFontSize,
    color: theme.palette.primary.main,
    lineHeight: "16px",
    marginTop: 8,
    marginBottom: 8,
  },
  severityHigh: {
    color: theme.error,
  },
  severityLow: {
    color: theme.warningColor,
  },
});

export default styles;
